import { IRefinanceAPIFeeData, IRefinanceAPIFeeResponse } from './IRefinanceFee';

export interface IPurchaseAPIFeeResponse extends IRefinanceAPIFeeResponse {
  seller_total?: number;
}

export interface IPurchaseAPIFeeData extends IRefinanceAPIFeeData {
  sellerTotal?: number;
}

export const convertIPurchaseFeeResponseToIPurchaseFeeData = ({
  buyer_total,
  paid_by_others_total,
  seller_total,
  ss_section,
  ss_label,
  buyer_at_closing,
  buyer_before_closing,
  seller_at_closing,
  seller_before_closing,
  ss_fee_order,
  ...rest
}: IPurchaseAPIFeeResponse): IPurchaseAPIFeeData => ({
  buyerTotal: buyer_total,
  paidByOthersTotal: paid_by_others_total,
  sellerTotal: seller_total,
  ssSection: ss_section,
  ssLabel: ss_label,
  buyerAtClosing: buyer_at_closing,
  buyerBeforeClosing: buyer_before_closing,
  sellerAtClosing: seller_at_closing,
  sellerBeforeClosing: seller_before_closing,
  ssFeeOrder: ss_fee_order,
  ...rest,
});

export const convertIPurchaseAPIFeeDataToIPurchaseAPIFeeResponse = ({
  buyerTotal,
  paidByOthersTotal,
  sellerTotal,
  ssSection,
  ssLabel,
  buyerAtClosing,
  buyerBeforeClosing,
  sellerAtClosing,
  sellerBeforeClosing,
  ssFeeOrder,
  ...rest
}: IPurchaseAPIFeeData): IPurchaseAPIFeeResponse => ({
  buyer_total: buyerTotal,
  paid_by_others_total: paidByOthersTotal,
  seller_total: sellerTotal,
  ss_section: ssSection,
  ss_label: ssLabel,
  buyer_at_closing: buyerAtClosing,
  buyer_before_closing: buyerBeforeClosing,
  seller_at_closing: sellerAtClosing,
  seller_before_closing: sellerBeforeClosing,
  ss_fee_order: ssFeeOrder,
  ...rest,
});
